// extracted by mini-css-extract-plugin
export default {"modal":"Uja-z","header":"Vja-z","fields":"Wja-z","error":"Xja-z","disabled":"Yja-z","reminderMsg":"Zja-z","errorMsg":"_ja-z","footer":"aka-z"};